import controller from './sliders-t1.controller';
import template from './sliders-t1.view.html';

let SlidersT1Component = {
  template,
  controller,
  bindings : {
    cbItems : '<',
    cbName : '<'
  }
};

export default SlidersT1Component;



/** WEBPACK FOOTER **
 ** ./www/components/home/sliders/sliders-t1/sliders-t1.component.js
 **/